import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
  sectionPadding,
  pageTopPadding,
  CONTENT_MAX_NARROW,
  CONTENT_INSET,
} from '../styles/layout';
import { GUIDES_PATH } from '../constants/guides';

const GOLD = '#C9A84C';
const BG = '#090909';
const TEXT = '#F5F0E8';
const MUTED = 'rgba(245, 240, 232, 0.72)';

const sections = [
  {
    title: 'Overview',
    content:
      'This Purchase Agreement covers orders for Digital Divot inflatable simulator enclosures and related packages submitted through our website. By checking the agreement box on the purchase form, you confirm that you have read and agree to these terms.',
  },
  {
    title: 'Order process',
    content:
      'Submitting the enclosure form is a purchase inquiry, not an instant online charge. Digital Divot will follow up to confirm package details, shipping method, timelines, and payment using the option you selected (card or Venmo/Zelle). Production begins after we receive your company logo and confirm payment arrangements.',
  },
  {
    title: 'Pricing and fees',
    content:
      'Package prices shown on the site are before any payment processing fees. Credit or debit card payments include a 2.9% processing fee. Venmo or Zelle payments do not include a processing fee. Applicable shipping and taxes, if any, will be confirmed before payment is collected.',
  },
  {
    title: 'Shipping',
    content:
      'Air shipping typically takes about 8 to 10 days and requires a valid EIN. Sea shipping typically takes about 30 days; enter N/A for EIN when choosing sea shipping. Exact timelines depend on destination, customs, and carrier conditions and will be confirmed with you.',
  },
  {
    title: 'Company logo',
    content:
      'A company logo file is required to begin production. Accepted formats include PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, and GIF. You represent that you have the right to use the logo provided and that Digital Divot may apply it for enclosure production as requested.',
  },
  {
    title: 'Cancellations and changes',
    content:
      'Once production has started, changes or cancellations may not be available or may incur additional costs. Contact admin@digitaldivotgolf.com as soon as possible if you need to update an order.',
  },
  {
    title: 'Contact',
    content:
      'Questions about this agreement or your order: admin@digitaldivotgolf.com.',
  },
];

const PurchaseAgreement = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 900);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <main style={{ backgroundColor: BG, color: TEXT, minHeight: '100vh' }}>
      <Helmet>
        <title>Purchase Agreement | Digital Divot</title>
        <meta
          name="description"
          content="Purchase Agreement for Digital Divot inflatable enclosure orders."
        />
      </Helmet>

      <div
        style={{
          maxWidth: CONTENT_MAX_NARROW,
          margin: '0 auto',
          padding: sectionPadding(isMobile),
          paddingTop: pageTopPadding(isMobile),
          paddingLeft: CONTENT_INSET,
          paddingRight: CONTENT_INSET,
          boxSizing: 'border-box',
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: '0.75rem',
            fontWeight: 700,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            color: GOLD,
          }}
        >
          Legal
        </p>
        <h1
          style={{
            margin: '0.55rem 0 0',
            fontSize: isMobile ? '1.85rem' : '2.4rem',
            fontWeight: 800,
            color: GOLD,
            letterSpacing: '-0.02em',
          }}
        >
          Purchase Agreement
        </h1>
        <p style={{ margin: '0.85rem 0 0', color: MUTED, lineHeight: 1.65 }}>
          Effective for enclosure purchases submitted through Digital Divot.
        </p>

        <div style={{ marginTop: '2rem', display: 'grid', gap: '1.5rem' }}>
          {sections.map((section) => (
            <section key={section.title}>
              <h2
                style={{
                  margin: 0,
                  fontSize: '1.05rem',
                  fontWeight: 800,
                  color: TEXT,
                }}
              >
                {section.title}
              </h2>
              <p style={{ margin: '0.55rem 0 0', color: MUTED, lineHeight: 1.7 }}>
                {section.content}
              </p>
            </section>
          ))}
        </div>

        <p style={{ margin: '2rem 0 0' }}>
          <Link to={`${GUIDES_PATH}#inflatable`} style={{ color: GOLD }}>
            Back to enclosure form
          </Link>
        </p>
      </div>
    </main>
  );
};

export default PurchaseAgreement;
